import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/ja'

const installElement = (app) => {
  app.use(ElementPlus, { locale })
}

export default installElement
